/** Pages paramètres au niveau entreprise (navbar : onglets + switch). */
export const SETTINGS_COMPANY_PAGE_TYPES = new Set([
  "settings_team",
  "settings_time_management",
  "settings_sectors",
  "settings_qualifications",
]);

/** Pages paramètres au niveau organisation (navbar : onglets, sans switch entreprise). */
export const ORGANIZATION_SETTINGS_PAGE_TYPES = new Set([
  "organization_settings",
  "organization_settings_companies",
  "organization_settings_integrations",
]);

export const ORGANIZATION_SETTINGS_PAGE_TYPE = "organization_settings";
